import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ABCOrdbogenIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    height: getDefaultHeight(svgProps, 30),
    ...svgProps,
    fill: "none",
    stroke: color ?? "currentColor",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("rect", {
      height: "18",
      rx: "1",
      width: "4",
      x: "11",
      y: "6"
    }), /*#__PURE__*/jsx("rect", {
      height: "18.1169",
      rx: "1",
      transform: "matrix(.96592583 -.25881905 .25881905 .96592583 -1.241603 4.639645)",
      width: "4",
      x: "17",
      y: "7.03528"
    }), /*#__PURE__*/jsx("rect", {
      height: "9",
      rx: "1",
      width: "4",
      x: "5",
      y: "15"
    })]
  });
};

export { ABCOrdbogenIcon };
//# sourceMappingURL=abc-ordbogen.js.map
